import React from "react";
import { Gavel } from "lucide-react";

// Top-level crime-category shortcuts that map 1:1 onto the `crime_type` enum
// coming back from /api/meta/crime-types. The "Abuse" chip uses `q=abuse` (a
// convenient substring shortcut) so it surfaces records whose enum is one of
// the several abuse-flavored categories (Animal Cruelty / Aggravated Cruelty /
// Failure to Provide Care) without us hard-coding a multi-select.
const CRIMES = [
  { k: "all", l: "All crimes" },
  { k: "abandonment", l: "Abandonment", crime_type: "Abandonment" },
  { k: "hoarding", l: "Hoarding", crime_type: "Hoarding" },
  { k: "torture", l: "Torture", crime_type: "Torture" },
  { k: "killing", l: "Killing", crime_type: "Killing of a Companion Animal" },
  { k: "aggravated", l: "Aggravated Cruelty", crime_type: "Aggravated Cruelty" },
  { k: "felony", l: "Felony Cruelty", crime_type: "Animal Cruelty (Felony)" },
  { k: "dogfighting", l: "Dog Fighting", crime_type: "Dog Fighting" },
  { k: "cockfighting", l: "Cockfighting", crime_type: "Cockfighting" },
  { k: "neglect", l: "Neglect", crime_type: "Animal Neglect" },
];

function isActive(c, filters) {
  const ct = filters.crime_type || "";
  if (c.k === "all") return !ct;
  return ct === c.crime_type;
}

export default function CrimeTypeFilterRow({ filters, setFilters }) {
  const apply = (c) => {
    setFilters((f) => ({
      ...f,
      crime_type: c.crime_type || "",
      page: 1,
    }));
  };

  return (
    <div
      className="border border-zinc-300 bg-white mt-3 px-4 py-3 flex flex-wrap items-center gap-2"
      data-testid="crime-type-filter-row"
    >
      <div className="flex items-center gap-2 pr-3 border-r border-zinc-300 mr-1">
        <Gavel size={13} className="text-red-600" />
        <span className="label-eyebrow">Filter by crime</span>
      </div>
      {CRIMES.map((c) => {
        const active = isActive(c, filters);
        return (
          <button
            key={c.k}
            type="button"
            onClick={() => apply(c)}
            className={`px-2.5 py-1 text-[11px] uppercase tracking-widest font-bold border transition-colors ${
              active
                ? "bg-red-600 text-white border-red-600"
                : "bg-white text-zinc-900 border-zinc-300 hover:border-red-600 hover:text-red-600"
            }`}
            data-testid={`crime-type-filter-${c.k}`}
          >
            {c.l}
          </button>
        );
      })}
    </div>
  );
}
